import {environment} from '../../util/Environment'
import {apiSlice} from '../store/Api'
import {
  IMediaUploadSignedUrlRequestDto,
  IMediaUploadSignedUrlResponseDto,
  IMediaDownloadSignedUrlRequestDto,
  IMediaDownloadSignedUrlResponseDto,
  IMediaUploadRequestDto,
  IMediaUploadResponseDto,
} from './Media.model'
export const mediaApi = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      mediaCreateUploadSignedUrl: builder.mutation<
        IMediaUploadSignedUrlResponseDto,
        IMediaUploadSignedUrlRequestDto
      >({
        query(body) {
          return {
            url: `${environment.apiUrl.media}/uploads`,
            method: 'POST',
            body,
          }
        },
      }),
      mediaUpload: builder.mutation<IMediaUploadResponseDto, IMediaUploadRequestDto>({
        query(body) {
          return {
            url: `${body.signedUrl}`,
            method: 'PUT',
            body: body.file,
            headers: {'NO_AUTH': 'YES'}
          }
        },
      }),
      mediaCreateDownloadSignedUrl: builder.mutation<
        IMediaDownloadSignedUrlResponseDto,
        IMediaDownloadSignedUrlRequestDto
      >({
        query(body) {
          return {
            url: `${environment.apiUrl.media}/downloads`,
            method: 'POST',
            body,
          }
        },
      }),
    }
  },
})

export const {
  useMediaCreateUploadSignedUrlMutation,
  useMediaUploadMutation,
  useMediaCreateDownloadSignedUrlMutation,
} = mediaApi
